export enum OrderingServiceStateEnum {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
  PAUSED = "PAUSED",
}
